export const drawPlatform = (ctx, platform, platformImages) => {
  if (platform.broken) return;
  
  // Choose the right platform image
  let platformImage = null;
  if (platformImages) {
    if (platform.type === 'moving') {
      platformImage = platformImages.platformMoving;
    } else if (platform.type === 'breakable') {
      platformImage = platformImages.platformBreakable;
    } else if (platform.type === 'fragile') {
      platformImage = platformImages.platformFragile;
      // ctx.globalAlpha = 0.6; // Keep fragile semi-transparent
    } else {
      platformImage = platformImages.platformSolid;
    }
  }
  
  // Draw platform image or fallback to colored rectangle
  if (platformImage) {
    ctx.drawImage(platformImage, platform.x, platform.y, platform.w, platform.h);
  } else {
    // Fallback to colored rectangles if images not loaded
    if (platform.type === 'moving') {
      ctx.fillStyle = '#2ca121ff';
    } else if (platform.type === 'breakable') {
      ctx.fillStyle = '#db6b21ff';
    } else if (platform.type === 'fragile') {
      ctx.fillStyle = '#a8a741ff';
    } else {
      ctx.fillStyle = '#e2d453ff';
    }
    ctx.fillRect(platform.x, platform.y, platform.w, platform.h);
  }
  
  ctx.globalAlpha = 1;
  
  // // Draw shadow
  // ctx.fillStyle = 'rgba(0,0,0,0.1)';
  // ctx.fillRect(platform.x + 2, platform.y + platform.h, platform.w, 3);
  
  // Draw spring if platform has one
if (platform.hasSpring && !platform.broken) {
  // Use spring image if available, otherwise draw rectangles
  if (platformImages && platformImages.spring) {
  const springWidth = 24;
  const springHeight = 16;
  // Calculate compression (0 = normal, 1 = fully compressed)
  const compression = platform.springCompression || 0;
  const compressedHeight = springHeight * (1 - compression * 0.5);  // Compress to 50% height
  const yOffset = springHeight - compressedHeight;  // Push down when compressed
  ctx.drawImage(
    platformImages.spring,
    platform.x + platform.w/2 - springWidth/2,
    platform.y - springHeight + 6,  // Changed: +6 moves it down to sit on platform
    springWidth,
    springHeight
  );

  } else {
    // Fallback to colored rectangles
    ctx.fillStyle = '#FF6B6B';
    ctx.fillRect(platform.x + platform.w/2 - 6, platform.y - 10, 12, 10);
    ctx.fillStyle = '#FF8888';
    ctx.fillRect(platform.x + platform.w/2 - 4, platform.y - 8, 8, 8);
  }
}
};

export const drawAllPlatforms = (ctx, platforms, platformImages) => {
  platforms.forEach(platform => {
    drawPlatform(ctx, platform, platformImages);
  });
};